<aside class="l-sidebar l-flex l-column" style="height: 100%;width: 20%;">
    <img
      class="off-mobile sidebar-logo"
      src="../../assets/icons/logo.svg"
      alt="Artisan Sonics"
    />

    <div class="userPanel"></div>
    <nav class="mainNav l-fg1 scroller"></nav>

    <app-docpanel></app-docpanel>
  </aside>

  <main class="l-deashboard" style="width: 80%;float: right;">
    <ng-container>
        <div class="l-flex patient-item" *ngFor="let pat of awlList;index as i" style="width: 100%;" (click)="openConsentForm=true;patservice.setPat(pat);loadConsent(pat.AWLID)">

            <div class="w100 patient-item-link" style="width: 100%;">

                <div class="l-table h100">
                    <span class="l-td-m patient-item-cell width"  >
                        Time: <strong>{{pat.ExamDate | date: 'shortTime'}}</strong>
                    </span>
                    <span class="l-td-m patient-item-cell width" >
                        ID: <strong>{{pat.ID}}</strong>
                    </span> 
                    <span class="l-td-m patient-item-cell patient-name-first width" [ngClass]="pat.Reason ?  'type-v': 'type-plus'" >
                        {{pat.First}} {{pat.Last}}
                    </span> 
                   
                    
                    <span class="l-td-m patient-item-cell patient-name-first width">
                        Phone: {{pat.Phone ? pat.Phone : pat.Mobile}}
                    </span>
                    <span class="l-td-m patient-item-cell patient-name-first width" *ngIf="(! loginService.ishospital || loginService.AWLExamNames) && pat.ExamCode">
                        {{pat.ExamCode}}
                    </span>
                    
                    <span class="l-td-m patient-item-cell patient-name-first width" *ngIf="loginService.separatedClinic && (loginService.isAdmin || loginService.userType == 'secretary')">
                        {{loginService.getDocByUID(pat.UID)}}
                    </span>
                    
                    <!-- <span class="l-td-m patient-item-cell patient-name-first width" >
                        {{pat.Status}}
                    </span> -->
                </div>			

            </div>
            
            

        </div>
    </ng-container>
   


  </main>
  <div *ngIf="openConsentForm" class="t-popup popup-patientDetails">

    <div class="t-popup-close"></div>
    
    <div   class="t-popup-frame maxw">
  <app-consent-form *ngIf="openConsentForm" (closed)="this.close(true)" (print)="printConsent()"></app-consent-form>
  </div>
  </div>